export default "__VITE_ASSET__CctjTOpa__"